import { getLists } from 'adapters/list';
import { List, RetailItem } from 'adapters/list/graphqlTypes';
import { SingleItemPayload } from 'helpers/pubsub';
import fetchPhraseIfNeeded from 'list/utils/fetch-phrase-if-needed';
import { removeFromLists } from './removeFromLists';
import { REMOVE_REQUEST } from 'list/pubsub';
import { h, render } from 'preact';
import { StrictMode } from 'preact/compat';
import RemoveFromListModal from './RemoveFromListModal';
import { reportError } from 'helpers/sentry';

const listsContainingItem = (lists: List[], productNumber: string) => {
    const listItemQuantityMap: Record<string, number> = {};

    const matchingLists = lists.filter((list: List) =>
        list?.retail?.items?.find((item: RetailItem) => {
            listItemQuantityMap[list.listId] = item.quantity;
            return item.itemNo === productNumber;
        })
    );

    return { matchingLists, listItemQuantityMap };
};
const handleRemoveFromListSubscription = (payload: SingleItemPayload) =>
    Promise.all([getLists(), fetchPhraseIfNeeded()])
        .then(([res]) => {
            const { matchingLists, listItemQuantityMap } = listsContainingItem(
                res.data.lists as List[],
                payload.productNumber
            );

            if ((res.data.lists.length <= 1 || matchingLists.length === 0) && !payload.alwaysShowModal) {
                return removeFromLists(payload, undefined, undefined, listItemQuantityMap);
            }
            render(
                <StrictMode>
                    <RemoveFromListModal
                        lists={matchingLists}
                        payload={payload}
                        destroy={() => {
                            render(null, document.getElementById('favs-remove-from-list') as HTMLElement);
                        }}
                    />
                </StrictMode>,
                document.getElementById('favs-remove-from-list') as HTMLElement
            );
        })
        .catch(e => {
            console.error(e);
            reportError(e as Error);
        });

export const initRemoveFromList = () => window.ikea.pubsub.subscribe(REMOVE_REQUEST, handleRemoveFromListSubscription);
